
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import HlxButton from '../commonComponents/button/button.tsx';
import imageComputer from './../../assets/images/placeholder-pc.png';
import styled, { ThemeContext } from 'styled-components';
import { useMediaQuery } from '@mui/material';

const StyledContainer = styled.div`
${({ requestVMOption }) => `
.confirm-device {
  max-width: 500px;
  margin: 0 auto;
  .title {
    text-align: center;
    margin-bottom: 50px;
    font-size: 42px;
    font-weight: bold;
    color: #58595B;
    @media(min-width: 600px){
      font-size: 48px;
    }
  }
  img {
    display: block;
    margin: 0 auto;
  }
  .content-confirm-detail{
    font-size: 1rem;
    text-align: center;
  }
  .italic-txt {font-style: italic;}
  .group-btn {
    display: flex;
    flex-direction: ${requestVMOption ? 'row' : 'column'};
    align-items: center;
    justify-content: ${requestVMOption ? 'center' : 'space-between'};
    .MuiCircularProgress-svg {color: #fff;}
    .or-statement {
      padding: 6px ${requestVMOption ? 12 : 0}px;
    }
  }
}
`}
`;

const groupBtnStyle = (isMobileView) => {
  return {
    fontSize: isMobileView ? "14px" : "12px"
  }
};

const DetailLostAndStolen = (props) => {
  const { onClickNo, onClickYes, isLoading, locale, contentConfirmDetail, titleConfirmDetail, requestVMOption } = props;
  const theme = useContext(ThemeContext);
  const smUp = useMediaQuery(`(min-width:${theme.breakpoints.sm})`);
  return (
    <StyledContainer requestVMOption={requestVMOption}>
      <div className="confirm-device">
        <h2 className="title">{titleConfirmDetail}</h2>
        <img src={imageComputer} alt="imagePc" title="imagePC" width={smUp ? 'unset': '250px'}/>
        <p className="content-confirm-detail">{contentConfirmDetail}</p>
        <div className="group-btn">
          <HlxButton
            onClick={onClickYes}
            disabled={isLoading}
            label={locale?.confirmDevice.button.yes}
            id="btn-confirmdevice-yes"
            style={groupBtnStyle(smUp)}
          />
          <span className="or-statement"><b>{locale?.confirmDevice.button.or}</b></span>
          <HlxButton
            loading={isLoading}
            label={requestVMOption ? locale?.confirmDevice.button.noVM : locale?.confirmDevice.button.no}
            onClick={onClickNo}
            id="btn-confirmdevice-no"
            style={groupBtnStyle(smUp)}
          />
        </div>
      </div>
    </StyledContainer>
  );
};

DetailLostAndStolen.propTypes = {
  isLoading: PropTypes.bool,
  onClickNo: PropTypes.func,
  onClickYes: PropTypes.func,
  locale: PropTypes.object,
  requestVMOption: PropTypes.bool
};

DetailLostAndStolen.defaultProps = {
  requestVMOption: false,
  onClickNo: () => { },
  onClickYes: () => { },
  contentConfirmDetail:"Click <strong>Yes, Replace Device</strong> to order a device to replace your missing one. Or click <strong>More Resources</strong>  to access a knowledge article with more information and options.",
  titleConfirmDetail: "Replacement Device",
  locale: {
    confirmDevice: {
      title: "Replacement Device",
      confirmDetail: "Click <strong>Yes, Replace Device</strong> to order a device to replace your missing one. Or click <strong>More Resources</strong>  to access a knowledge article with more information and options.",
      button: {
        yes: "Yes, Replace Device",
        no: "More Resources",
        or: "or",
      }
  },
  }
};

export default DetailLostAndStolen;

